import { render, staticRenderFns } from "./PlayerSettings.vue?vue&type=template&id=0331ae39"
import script from "./PlayerSettings.vue?vue&type=script&lang=js"
export * from "./PlayerSettings.vue?vue&type=script&lang=js"
import style0 from "./PlayerSettings.vue?vue&type=style&index=0&id=0331ae39&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports